<div class="main">
    <app-header-section></app-header-section>
    <app-breadcrumb-explore-four></app-breadcrumb-explore-four>
    <app-explore-five-section></app-explore-five-section>
    <app-footer-section></app-footer-section>
    <app-modal-search></app-modal-search>
    <app-modal-menu></app-modal-menu>
    <app-scrollup></app-scrollup>
</div>
